const items = [
  {
    href: '/app/briefing',
    icon: 'Clipboard',
    title: '종목 브리핑'
  },
  {
    href: '/app/profits',
    icon: 'Clipboard',
    title: '수익현황'
  },
  {
    href: '/app/vip-contacts',
    icon: 'Clipboard',
    title: 'VIP 문의'
  },
  {
    href: '/app/membership',
    icon: 'Clipboard',
    title: '회원관리(멤버십)'
  },
  {
    href: '/app/stock-recommend',
    icon: 'Clipboard',
    title: '종목추천'
  },
  {
    href: '/404',
    icon: 'AlertCircle',
    title: 'Error'
  }
];

export default items;
